document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('Details-menu-drawer-container');
  if (!drawer) return;

  drawer.addEventListener('toggle', (event) => {
    const menuItems = drawer.querySelectorAll('.menu-drawer__menu-item.list-menu__item');

    if (event.target.open) {
      setTimeout(() => {
        menuItems.forEach((item, index) => {
          item.style.opacity = 0;
          const isActive = item.classList.contains('link') && item.classList.contains('menu-drawer__menu-item--active');
          item.style.animation = `${isActive ? 'menuSlideInActive' : 'menuSlideIn'} 0.4s ease-out forwards`;
          item.style.animationDelay = `${index * 0.06}s`;
        });
      }, 40);
      return;
    }

    menuItems.forEach((item) => {
      item.style.animation = 'none';
      item.style.animationDelay = '';
      item.style.opacity = '';
    });
  });
});
